export { default } from './WideMedia'
